<div class="header">
  <h4 class="header-text">
    {{ 'financeDialog.header' | translateIn }}
  </h4>

  <button
    class="close"
    type="button"
    puButton
    size="m"
    uiType="quaternary"
    [onlyIcon]="true"
    (click)="close()">
    <pu-icon iconName="close" size="16" />
  </button>
</div>

<div class="body">
  <img class="image" [src]="assetsUrl + '/assets/images/coins.png'" alt="message.png" />

  <div class="text">
    <div class="description">
      <p>{{ 'financeDialog.text.description' | translateIn }}</p>

      <a
        class="link"
        puButton
        uiType="quaternary"
        [href]="financeConfluenceLink"
        target="_blank"
      >
        {{ 'financeDialog.text.button' | translateIn }}
      </a>
    </div>

    <p class="questions">
      {{ 'financeDialog.text.questions' | translateIn }}
    </p>
  </div>

  <div class="actions">
    <button
      type="button"
      puButton
      size="l"
      uiType="primary"
      (click)="openSupport()"
    >{{ 'financeDialog.buttons.message' | translateIn }}</button>

    <button
      type="button"
      puButton
      size="l"
      uiType="secondary"
      (click)="close()"
    >
      {{ 'supportForm.buttons.close' | translateIn }}
    </button>
  </div>
</div>
